import React, { useState, useEffect, useRef } from 'react';
import { Outlet } from 'react-router';
import assignedVia_1 from '../../../../assets/images/assignedVia_1.png';
import assignedVia_2 from '../../../../assets/images/assignedVia_2.png';
import assignedVia_3 from '../../../../assets/images/assignedVia_3.png';
import assignedVia_4 from '../../../../assets/images/assignedVia_4.png';
import assignMethodImg from '../../../../assets/images/personWhiteboard.png';
import AssignmentPreviewModal from '../../components/AssignmentPreviewModal';
import Modal from '../../../../components/Modal/index';
import CustomToast from '../../../../components/Toast/index';
import { useAssignmentContext } from '../../context';
import { useDispatch } from 'react-redux';
import '../../assignments.scss';
import {
  useLazyGetBasicAssignmentDetailsQuery,
  useSaveAssignmentMethodMutation
} from '../../../../features/authentication/assignmentApislice';
import { useParams, NavLink, useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { setSelectedAssignmentId } from '../../../../features/authentication/authSlice';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';
import FERPA from '../../../../components/FERPA/FerpaComponent';

const items = [
  {
    id: 1,
    name: 'Assignment Result',
    path: 'assignment_result'
  },
  {
    id: 5,
    name: 'Assign To Students',
    path: 'assign_to_students',
    comingSoon: false
  },
  {
    id: 3,
    name: 'Self Assign',
    path: 'self_assign',
    comingSoon: false
  },
  {
    id: 4,
    name: 'Upload Offline Answers',
    path: 'upload_offline_answers',
    comingSoon: false
  },
  {
    id: 2,
    name: 'Reports',
    path: 'reports',
    comingSoon: false
  }
];

const assignedViaOptions = [
  { assignedViaId: 1, className: 'castle', name: 'Castle', image: assignedVia_1 },
  { assignedViaId: 2, className: 'google', name: 'Google Classroom', image: assignedVia_2 },
  { assignedViaId: 3, className: 'schoology', name: 'Schoology', image: assignedVia_3 },
  { assignedViaId: 4, className: 'canvas', name: 'Canvas', image: assignedVia_4 }
];

const Index = () => {
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showAssignmentMethodModal, setShowAssignmentMethodModal] = useState(false);
  const [showFerpa, setShowFerpa] = React.useState(false);
  const dispatch = useDispatch();
  const [getAssignmentDetailsQuery] = useLazyGetBasicAssignmentDetailsQuery();
  const [saveAssignmentMethod, saveAssignmentMethodResults] = useSaveAssignmentMethodMutation();
  const [updateTab, setUpdateTab] = useState(false);

  const {
    assignmentName,
    assignmentAssignedViaDetails,
    assignmentId,
    setAssignmentId,
    setAssignmentName,
    setAssignmentAssignedViaDetails,
    assignedStatus
  } = useAssignmentContext();
  const urlParameters = useParams();
  const [assignedViaDetails, setAssignedViaDetails] = useState(
    assignedViaOptions.find((c) => c.assignedViaId == assignmentAssignedViaDetails?.id)
  );
  const navigate = useNavigate();
  const assignmentMethodRef = useRef();

  useEffect(() => {
    if (!assignmentId && urlParameters?.Id) {
      getAssignmentDetailsQuery(urlParameters.Id).then((response) => {
        if (!response.data.assignedViaId) {
          setShowAssignmentMethodModal(true);

          setAssignedViaDetails(assignedViaOptions.find((c) => c.assignedViaId == 1));
          setAssignmentAssignedViaDetails({ id: 1, name: 'Castle' });
        } else {
          setAssignedViaDetails(
            assignedViaOptions.find((c) => c.assignedViaId == response.data.assignedViaId)
          );
          setAssignmentAssignedViaDetails({
            id: response.data.assignedViaId,
            name: response.data.assignedViaName
          });
        }

        setAssignmentName(response.data.assignmentName);
        setAssignmentId(urlParameters.Id);
        dispatch(setSelectedAssignmentId({ assignmentId: urlParameters?.Id }));
      });
    } else if (assignmentId) {
      dispatch(setSelectedAssignmentId({ assignmentId: assignmentId }));
    }

    if (assignmentId && !assignmentAssignedViaDetails.id) {
      setShowAssignmentMethodModal(true);
    }

    if (assignmentId && assignmentAssignedViaDetails.id) {
      setAssignmentAssignedViaDetails({
        name: assignedViaDetails.name,
        id: assignmentAssignedViaDetails.id
      });
    }

    if (assignedStatus == 4) {
      navigate(`/assignments/${assignmentId}/manage_assign/assign_to_students`);
    }
  }, []);

  async function handleSaveAssignmentMethod() {
    try {
      await saveAssignmentMethod({
        assignmentIds: [assignmentId],
        assignedViaId: assignmentMethodRef.current.value
      }).unwrap();

      var assignedOption = assignedViaOptions.find(
        (c) => c.assignedViaId == assignmentMethodRef.current.value
      );
      setAssignedViaDetails(assignedOption);
      setAssignmentAssignedViaDetails({
        id: assignedOption.assignedViaId,
        name: assignedOption.name
      });
      setShowAssignmentMethodModal(false);
      CustomToast('The assignment method has been updated', 'success');
    } catch (ex) {
      CustomToast('Something went wrong, could not update assignment method', 'error');
      console.log(ex);
    }
  }

  useEffect(() => {
    const url = window.location.href;
    const endString = url.substr(url.lastIndexOf('/') + 1);
    endString === 'assignment_result'
      ? setShowFerpa(true)
      : (setShowFerpa(false));
  }, [updateTab]);

  return (
    <div className="white-card">
      <div className="row align-items-center mb-3">
        <div className="col-md-6">
          <h2 className="primary-title mb-md-0">
            {`Assignment: ${assignmentName}`}
            {assignedViaDetails && (
              <span
                className={`manage-assign-card manage-badge ${assignedViaDetails.className} ms-2`}>
                <span>
                  <img
                    src={assignedViaDetails.image}
                    className="img-fluid"
                    alt={`Assigned via ${assignedViaDetails.name}`}
                  />
                </span>
                {assignedViaDetails.name}
              </span>
            )}
          </h2>
        </div>
        <div className="col-md-6 d-flex gap-3 flex-column flex-sm-row  justify-content-between justify-content-md-end align-items-center">
          <button onClick={() => setShowPreviewModal(true)} className="btn btn-castleWhite ms-auto">
            Preview Assignment
          </button>
          <button
            onClick={() => navigate('/assignments')}
            className="btn btn-castleWhite mr-3 btn-width">
            Back
          </button>
          <button
            onClick={() => navigate(`/classroom_view/${assignmentId}`)}
            className="btn btn-castleRed">
            Classroom View
          </button>
        </div>
      </div>
      <div className="row message-tab align-items-center mb-3">
        <div className="col-xl-11">
          <div className="primary-tab d-md-block mb-md-0">
            <div className="btn-group">
              {items.map((item) => (
                <>
                  {item.comingSoon ? (
                    <OverlayTrigger
                      key="1245455"
                      placement="top"
                      overlay={
                        <Tooltip id="45824582" className="custom-tooltip">
                          <p className="mb-0">Coming Soon!</p>
                        </Tooltip>
                      }>
                      <a key={item.id} className="btn" to={item.path} disabled={true}>
                        {' '}
                        {item.name}{' '}
                      </a>
                    </OverlayTrigger>
                  ) : (
                    <NavLink
                      key={item.id}
                      className="btn rounded"
                      to={item.path}
                      onClick={() => setUpdateTab(!updateTab)}>
                      {' '}
                      {item.name}{' '}
                    </NavLink>
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
        <div className="col-xl-1 text-xl-end ps-xl-0 mt-3 mt-xl-0">
          {showFerpa && <FERPA />}
        </div>
      </div>
      {assignmentId && <Outlet />}
      {showPreviewModal && (
        <AssignmentPreviewModal
          isOpen={showPreviewModal}
          onClose={() => setShowPreviewModal(false)}
        />
      )}

      <Modal
        contentWidth="40%"
        isOpen={showAssignmentMethodModal}
        titleName={'Assignment Method'}
        onClose={() => navigate('/assignments')}
        disableBackdropClose={true}>
        <div className="d-flex flex-column align-items-center">
          <div
            className="mb-3"
            style={{
              backgroundImage: `url(${assignMethodImg})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100%',
              height: '130px',
              width: '199px'
            }}></div>
          <div>How will you assign this assignment?</div>
          <div className="d-flex flex-row w-50 my-4 align-items-center justify-content-evenly">
            <span>Assigned Via</span>
            <Form.Select ref={assignmentMethodRef} style={{ maxWidth: '50%' }} defaultValue="1">
              {assignedViaOptions.map((item, index) => {
                return (
                  <option key={`assignmentMethodKey${index}`} value={item.assignedViaId}>
                    {item.name}
                  </option>
                );
              })}
            </Form.Select>
          </div>
          <div className="d-flex flex-row w-50 justify-content-evenly">
            <Button
              variant="castleGray"
              style={{ width: '45%' }}
              onClick={() => navigate('/assignments')}>
              Cancel
            </Button>
            <Button
              variant="castleRed"
              style={{ width: '45%' }}
              onClick={(e) => handleSaveAssignmentMethod(e)}
              disabled={saveAssignmentMethodResults.isLoading}>
              Save
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Index;
